import {Observable} from 'rxjs';

export abstract class NachweisService {
  abstract getNachweise(antragId: string, kontext: string): Observable<any>;

  abstract cleanupNachweise(antragId: string): Observable<any>;

  abstract upload(formData: FormData, id, kontext, parent?): Observable<any>;

  abstract deleteFile(id, nachweisId, kontext): Observable<any>;

  abstract download(id, nachweisId, kontext): Observable<any>;

  abstract convertStatus(id, nachweisId, kontext): Observable<any>;
}
